export const confirmDialogBodyStyles = 'tw:mb-4 tw:text-[var(--color-text-primary)]';
export const confirmDialogFooterStyles = 'tw:flex tw:justify-end tw:gap-2';
